export default {
	platformNotifications: state => state.platformNotifications,
	accessToken: state => state.accessToken
}